//Table
import MaterialTable, { MTableToolbar } from "material-table";

//Chart js
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import { Box, Stack, Typography } from '@mui/material';
import DashboardOrdersExportButton from '../components/DashboardOrdersExportButton';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

//Opciones para la gráfica
export const options = {
    responsive: true,
    plugins: {
        legend: {
            position: 'top'
        }
    }
};

//Columna de la tabla
const defaultColumns = [
    {
        title: "Mes",
        field: "mes"
    },
    {
        title: "$",
        field: "ganancia"
    }
];

function TicketPromedio({
    tableTitle,
    title,
    data,
    dataTable,
    columns = defaultColumns,
    showHeading = true,
    showTable = true,
    exportConfig
}) {
    const resolvedTitle = title || `Ticket promedio ${tableTitle}`;

    return (
        <>
            {showHeading && (
                <Stack
                    direction={{ xs: 'column', sm: 'row' }}
                    justifyContent="space-between"
                    alignItems={{ xs: 'stretch', sm: 'center' }}
                    spacing={1}
                    sx={{ mb: 1 }}
                >
                    <Typography variant='h5' sx={{ fontWeight: 'light' }}>
                        {resolvedTitle}
                    </Typography>
                    {exportConfig && (
                        <DashboardOrdersExportButton {...exportConfig} />
                    )}
                </Stack>
            )}
            {/* Gráfica */}
            <div style={{ width: '100%', maxWidth: '100%', overflow: 'hidden' }}>
                <Line options={options} data={data} style={{ maxWidth: '100%' }} />
            </div>
            {/* fin gráfica */}

            {/* inicia tabla */}
            {showTable && <Box sx={{ width: '100%', mt: 4 }}>
                <MaterialTable
                    title={resolvedTitle}
                    data={dataTable}
                    columns={columns}
                    options={{
                        exportButton: false,
                        headerStyle: {
                            zIndex: 1
                        },
                    }}
                    components={{
                        Toolbar: props => (<MTableToolbar {...props} classes={{ root: "dummy-class" }} />),
                    }}
                    localization={{
                        body: {
                            emptyDataSourceMessage: "No hay datos por mostrar",
                            addTooltip: 'Agregar',
                            deleteTooltip: 'Eliminar',
                            editTooltip: 'Editar',
                            filterRow: {
                                filterTooltip: 'Filtrar'
                            },
                            editRow: {
                                deleteText: '¿Segura(o) que quiere eliminar?',
                                cancelTooltip: 'Cancelar',
                                saveTooltip: 'Guardar'
                            }
                        },
                        grouping: {
                            placeholder: "Arrastre un encabezado aquí para agrupar",
                            groupedBy: 'Agrupado por:'
                        },
                        header: {
                            actions: 'Acciones'
                        },
                        pagination: {
                            labelDisplayedRows: '{from}-{to} de {count}',
                            labelRowsSelect: 'filas',
                            labelRowsPerPage: 'Filas por página:',
                            firstAriaLabel: 'Primera página',
                            firstTooltip: 'Primera página',
                            previousAriaLabel: 'Página anterior',
                            previousTooltip: 'Página anterior',
                            nextAriaLabel: 'Página siguiente',
                            nextTooltip: 'Página siguiente',
                            lastAriaLabel: 'Última página',
                            lastTooltip: 'Última página'
                        },
                        toolbar: {
                            addRemoveColumns: 'Agregar o eliminar columnas',
                            nRowsSelected: '{0} fila(s) seleccionada(s)',
                            showColumnsTitle: 'Mostrar columnas',
                            showColumnsAriaLabel: 'Mostrar columnas',
                            exportTitle: 'Exportar',
                            exportAriaLabel: 'Exportar',
                            exportName: "Exportar como CSV",
                            exportPDFName: "Exportar como PDF",
                            searchTooltip: 'Buscar',
                            searchPlaceholder: 'Buscar'
                        }
                    }}
                />
            </Box>}
            {/* Fin de la tabla */}
        </>
    );
};

export default TicketPromedio;
